import React from "react";
import styles from "./NotificationPerformanceTracking.module.scss";
import DynamicTableFilters from "../../../../common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters";
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable";
import { performanceTrackingTableData } from "../../../../../views/AdminPortal/dummyData";
import ActionButton from "../../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton";
import ComponentBackButton from "../../../../common/AdminCommonComponents/Buttons/ComponentBackButton/ComponentBackButton";

const NotificationPerformanceTracking = ({ setIsTrackingOpen }) => {
    const options = [
        { label: "View details" },
        { label: "Edit" },
        { label: "Delete" },
    ];

    const columns = [
        {
            name: "Sr.",
            selector: (_, index) => index + 1,
            center: "true",
            width: "80px",
        },
        {
            name: "Title",
            selector: (row) => row.title,
            center: "true",
            minWidth: "120px",
        },
        {
            name: "Sent Date",
            selector: (row) => row.sentDate,
            center: "true",
            minWidth: "120px",
        },
        {
            name: "Delivered",
            selector: (row) => row.delivered,
            center: "true",
        },
        {
            name: "Opened",
            selector: (row) => row.opened,
            center: "true",
        },
        {
            name: "Click-Through Rate",
            selector: (row) => row.ctr,
            center: "true",
            minWidth: "180px",
        },
        {
            name: "Conversions",
            selector: (row) => row.conversions,
            center: "true",
        },
        {
            name: "Actions",
            cell: () => <ActionButton options={options} />,
            center: "true",
        },
    ];

    const handleApply = (filters) => {
        console.log("Applied Filters:", filters);
    };

    const handleClear = () => {
        console.log("Filters Cleared");
    };
    return (
        <div className={styles.filterTableWrapper}>
            <div className={styles.headingBtnWrapper}>
                <ComponentBackButton onClick={() => setIsTrackingOpen(false)} />
                <h5 className={styles.sectionHeading}>Notification Performance Tracking</h5>
            </div>
            <DynamicTableFilters
                componentName={"Notification Performance Tracking"}
                onApply={handleApply}
                onClear={handleClear}
            />
            <div className={styles.tableWrapper}>
                <DynamicDatatable
                    data={performanceTrackingTableData}
                    columns={columns}
                    type="gray"
                    pagination
                    highlightOnHover
                    responsive
                />
            </div>
        </div>
    );
};

export default NotificationPerformanceTracking;